(function () {
  function initStickyHomeCta(root) {
    var customSelector = (root.getAttribute('data-hero-selector') || '').trim();
    var hero = customSelector
      ? document.querySelector(customSelector)
      : document.querySelector('#MainContent.index-page > .shopify-section:first-child .banner');

    var panel = root.querySelector('[data-sticky-home-cta-panel]');
    if (!hero || !panel) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            panel.classList.remove('is-visible');
            panel.setAttribute('aria-hidden', 'true');
          } else {
            panel.classList.add('is-visible');
            panel.setAttribute('aria-hidden', 'false');
          }
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );

    observer.observe(hero);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sticky-home-cta-root]').forEach(initStickyHomeCta);
  });
})();
